<template>
  <v-layout column justify-space-between class="pa-2">
    <v-layout row justify-start class="mb-2">
      <v-flex v-for="t in teamTags" shrink :key="t.name">
        <GeoTag :geotag="t" :showWorksites="false" />
      </v-flex>
    </v-layout>

    <v-layout items-center row v-if="!teamTags || teamTags.length === 0">
      <v-flex>
        <h3>
          No states added yet.
        </h3>
      </v-flex>
      <v-flex>
        <v-dialog
          full-width
          persistent
          v-model="addTeamDialog"
          max-width="600"
          :disabled="teamsPullOffSelected.length > 0"
        >
          <v-btn
            block
            color="success"
            :disabled="teamsPullOffSelected.length > 0"
            slot="activator"
          >
            Add Team
          </v-btn>
          <v-card>
            <v-card-title class="headline">
              <v-layout align-center justify-space-between>
                <v-flex>
                  Add Employee to States
                </v-flex>
                <v-flex class="text-xs-right">
                  <v-btn icon @click="addTeamDialog = false">
                    <v-icon>
                      close
                    </v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-card-title>

            <v-card-text>
              <v-layout column>
                <v-flex>
                  <v-layout row>
                    <v-flex class="mr-2">
                      <v-autocomplete
                        multiple
                        label="States"
                        :items="stateTags"
                        item-text="name"
                        item-value="id"
                        clearable
                        @change="addTeams($event)"
                      />
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex>
                  <v-autocomplete
                    label="Locations"
                    v-model="teamsSelected"
                    :items="teamsNotOn"
                    chips
                    multiple
                    item-text="name"
                    return-object
                    clearable
                  >
                    <template slot="item" slot-scope="data">
                      <LocationName :location="data.item" showColor noLink />
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-spacer></v-spacer>
            <v-layout row>
              <v-flex>
                <v-btn color="grey" flat @click="addTeamDialog = false"
                  >Nevermind</v-btn
                >
              </v-flex>
              <v-flex>
                <v-layout column>
                  <v-btn
                    color="success"
                    small
                    :loading="apiCallPending"
                    @click="addSelectedTeams"
                    :disabled="teamsSelected.length == 0"
                  >
                    Add Selected Teams
                  </v-btn>
                  <v-btn
                    color="success"
                    small
                    :loading="apiCallPending"
                    @click="addToAllTeams"
                    :disabled="teamsSelected.length > 0"
                  >
                    Add To All Teams
                  </v-btn>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-flex v-else>
      <v-layout row justify-between>
        <v-flex class="mr-2" grow>
          <v-card>
            <v-card-title>
              <h2 class="all-caps">
                Current Teams
              </h2>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="teamSearch"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :items="onTeams"
              :search="teamSearch"
              :headers="teamHeaders"
              :pagination.sync="defaultSort"
              select-all
              item-key="name"
            >
              <template slot="headers" slot-scope="{ header }">
                <tr>
                  <th>
                    <v-checkbox
                      hide-details
                      @click.stop="toggleAll"
                    ></v-checkbox>
                  </th>
                  <th v-for="header in teamHeaders" :key="header.text">
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="{ item }">
                <tr @click="toggleTeamPullOffSelected(item)">
                  <td>
                    <v-checkbox
                      :input-value="teamIsPullOffSelected(item)"
                      primary
                      hide-details
                    ></v-checkbox>
                  </td>
                  <td>
                    <LocationName :location="item" showColor noLink />
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>

        <v-flex shrink>
          <v-flex>
            <div class="d-inline-block mr-2">
              <h2 class="all-caps">Category</h2>
            </div>
            <div class="d-inline-block">
              <v-select
                v-model="employeeColorCategoryId"
                :items="colorCategoriesAvailable"
                item-text="name"
                item-value="id"
                label="Category"
                :success-messages="categorySuccesses"
                :error-messages="categoryErrors"
                :loading="categoryLoading"
              >
              </v-select>
            </div>
          </v-flex>

          <v-flex>
            <v-layout column>
              <v-flex>
                <v-dialog
                  full-width
                  persistent
                  v-model="addTeamDialog"
                  max-width="600"
                  :disabled="teamsPullOffSelected.length > 0"
                >
                  <v-btn
                    block
                    :disabled="teamsPullOffSelected.length > 0"
                    slot="activator"
                  >
                    Add Team
                  </v-btn>
                  <v-card>
                    <v-card-title class="headline">
                      <v-layout align-center justify-space-between>
                        <v-flex>
                          Add Employee to Teams
                        </v-flex>
                        <v-flex class="text-xs-right">
                          <v-btn icon @click="addTeamDialog = false">
                            <v-icon>
                              close
                            </v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-title>

                    <v-card-text>
                      <v-layout column>
                        <v-flex>
                          <v-layout row>
                            <v-flex class="mr-2">
                              <v-autocomplete
                                multiple
                                label="States"
                                :items="stateTags"
                                item-text="name"
                                item-value="id"
                                clearable
                                @change="addTeams($event)"
                              />
                            </v-flex>
                          </v-layout>
                        </v-flex>

                        <v-flex>
                          <v-autocomplete
                            label="Choose Teams"
                            v-model="teamsSelected"
                            :items="teamsNotOn"
                            chips
                            multiple
                            item-text="name"
                            return-object
                            clearable
                          >
                            <template slot="item" slot-scope="data">
                              <LocationName
                                :location="data.item"
                                showColor
                                noLink
                              />
                            </template>
                          </v-autocomplete>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-spacer></v-spacer>
                    <v-layout row>
                      <v-flex>
                        <v-btn color="grey" flat @click="addTeamDialog = false"
                          >Nevermind</v-btn
                        >
                      </v-flex>
                      <v-flex>
                        <v-layout column>
                          <v-btn
                            color="success"
                            small
                            :loading="apiCallPending"
                            @click="addSelectedTeams"
                            :disabled="teamsSelected.length == 0"
                          >
                            Add Selected Teams
                          </v-btn>
                          <v-btn
                            color="success"
                            small
                            :loading="apiCallPending"
                            @click="addToAllTeams"
                            :disabled="teamsSelected.length > 0"
                          >
                            Add To All Teams
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-dialog>
              </v-flex>

              <v-flex>
                <v-btn
                  block
                  @click="pullOffTeams"
                  :disabled="teamsPullOffSelected.length == 0"
                >
                  Pull Off
                </v-btn>
              </v-flex>

              <v-flex>
                <v-dialog
                  full-width
                  persistent
                  v-model="addTeamsIneligibleDialog"
                  max-width="600"
                >
                  <v-btn block slot="activator">
                    Add Ineligible Team
                  </v-btn>
                  <v-card>
                    <v-card-title class="headline">
                      <v-layout align-center justify-space-between>
                        <v-flex>
                          Add Teams Employee Ineligible For
                        </v-flex>
                        <v-flex class="text-xs-right">
                          <v-btn icon @click="addTeamsIneligibleDialog = false">
                            <v-icon>
                              close
                            </v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card-title>
                    <v-card-text>
                      <v-autocomplete
                        label="Choose Ineligible Teams"
                        v-model="ineligibleTeamsSelected"
                        :items="allTeamsExceptIneligible"
                        chips
                        multiple
                        item-text="name"
                        return-object
                        clearable
                      >
                        <template slot="item" slot-scope="data">
                          <LocationName
                            :location="data.item"
                            showColor
                            noLink
                          />
                        </template>
                      </v-autocomplete>
                    </v-card-text>
                    <v-spacer></v-spacer>
                    <v-layout row>
                      <v-flex>
                        <v-btn
                          color="grey"
                          flat
                          @click="addTeamsIneligibleDialog = false"
                          >Nevermind</v-btn
                        >
                      </v-flex>
                      <v-flex>
                        <v-layout column>
                          <v-btn
                            color="success"
                            small
                            :loading="apiCallPending"
                            @click="addSelectedIneligibleTeams"
                          >
                            Add Selected Teams
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-dialog>
              </v-flex>

              <v-flex>
                <v-btn
                  block
                  :loading="apiCallPending"
                  @click="removeSelectedIneligibleTeams"
                  :disabled="ineligibleTeamsSelectedToRemove.length == 0"
                >
                  Remove Selected Ineligible Teams
                </v-btn>
              </v-flex>

              <v-flex>
                <template>
                  <v-card class="pa-2">
                    <v-card-title>
                      <h2 class="all-caps">
                        Ineligible Teams
                      </h2>
                      <v-text-field
                        v-model="ineligibleTeamSearch"
                        append-icon="search"
                        label="Search"
                        single-line
                        hide-details
                        class="ml-2"
                      ></v-text-field>
                    </v-card-title>

                    <v-flex>
                      <v-dialog
                        full-width
                        persistent
                        v-model="narrativeNotesDialog"
                        max-width="600"
                      >
                        <v-btn
                          block
                          slot="activator"
                          :color="
                            employee.narrative_notes ? 'orange lighten-2' : null
                          "
                        >
                          Edit Narrative Notes
                        </v-btn>
                        <v-card>
                          <v-card-title class="headline">
                            <v-layout align-center justify-space-between>
                              <v-flex>
                                Narrative Notes
                              </v-flex>
                              <v-flex class="text-xs-right">
                                <v-btn icon @click="resetNarrativeNotes">
                                  <v-icon>
                                    close
                                  </v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                          </v-card-title>
                          <v-card-text>
                            <v-textarea
                              v-model="employee.narrative_notes"
                              box
                              rows="10"
                              auto-grow
                            >
                            </v-textarea>
                          </v-card-text>
                          <v-spacer></v-spacer>
                          <v-layout row>
                            <v-flex>
                              <v-btn
                                color="grey"
                                flat
                                @click="resetNarrativeNotes"
                                >Nevermind</v-btn
                              >
                            </v-flex>
                            <v-flex>
                              <v-layout column>
                                <v-btn
                                  color="success"
                                  small
                                  :loading="narrativeNotesApiCallPending"
                                  @click="saveNarrativeNotes"
                                >
                                  Save
                                </v-btn>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-dialog>
                    </v-flex>

                    <v-data-table
                      :items="ineligibleTeams"
                      :search="ineligibleTeamSearch"
                      :headers="ineligibleTeamHeaders"
                      :pagination.sync="defaultSort"
                      select-all
                      item-key="name"
                    >
                      <template slot="headers" slot-scope="{ header }">
                        <tr>
                          <th>
                            <v-checkbox
                              hide-details
                              @click.stop="ineligibleToggleAll"
                            ></v-checkbox>
                          </th>
                          <th
                            v-for="header in ineligibleTeamHeaders"
                            :key="header.text"
                          >
                            {{ header.text }}
                          </th>
                        </tr>
                      </template>
                      <template slot="items" slot-scope="{ item }">
                        <tr @click="toggleTeamRemoveIneligibleSelected(item)">
                          <td>
                            <v-checkbox
                              :input-value="
                                teamIsRemoveIneligibleSelected(item)
                              "
                              primary
                              hide-details
                            ></v-checkbox>
                          </td>
                          <td>
                            <LocationName :location="item" showColor noLink />
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </template>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Info from "@/components/hr/info.vue";
import EmployeeField from "@/components/hr/employee-field.vue";
import EmployeeDateField from "@/components/hr/employee-date-field.vue";
import EmployeeCheckboxField from "@/components/hr/employee-checkbox-field.vue";
import EmployeeSelect from "@/components/hr/employee-select.vue";
import GeoTag from "../geotags/geo-tag.vue";

export default {
  components: {
    Info,
    EmployeeField,
    EmployeeDateField,
    EmployeeCheckboxField,
    EmployeeSelect,
    GeoTag
  },
  mounted: function() {
    this.$store.dispatch("geotags/getAll");
    this.$store.dispatch("colorCategories/getAll");
    this.$store.dispatch("teams/getAll", this.user.id);
  },
  props: ["employee"],
  computed: {
    ...mapGetters("geotags", ["tagByID", "stateTags", "regionTags"]),

    teamTags() {
      const segments = this.onTeams.map(location => location.segments);
      const uniqSegments = new Set();
      segments.flat().forEach(x => {
        if (x.segment_type === "region") {
          return;
        }
        const obj = {
          id: x.id,
          name: x.name,
          segmentType: x.segment_type
        };
        uniqSegments.add(JSON.stringify(obj));
      });
      return Array.from(uniqSegments)
        .map(t => JSON.parse(t))
        .sort((a, b) => {
          if (a.segmentType < b.segmentType) {
            return -1;
          }
          if (a.segmentType > b.segmentType) {
            return 1;
          }
          return 0;
        });
    },

    teamsNotOn: function() {
      return this.availableTeams
        .slice()
        .sort((a, b) => {
          var nameA = a.name.toLowerCase(),
            nameB = b.name.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        })
        .filter(
          t =>
            !this.employeeOnTeam(t.id) && this.employeeIneligibleForTeam(t.id)
        );
      // translates to "filter out teams this employee isn't on and also filter out teams this employee is not eligible for"
      // whereas using "||" would show only one or the other
    },
    ...mapState("teams", {
      availableTeams: state => state.teams
    }),
    ...mapState("userAuth", ["user"]),
    onTeams: function() {
      return this.employee.teams;
    },
    allTeamsExceptIneligible: function() {
      return this.availableTeams
        .slice()
        .sort((a, b) => {
          var nameA = a.name.toLowerCase(),
            nameB = b.name.toLowerCase();
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        })
        .filter(t => this.employeeIneligibleForTeam(t.id));
    },
    ineligibleTeams: function() {
      return this.employee.ineligible_teams;
    },
    colorCategoriesAvailable: function() {
      return this.$store.state.colorCategories.colorCategories;
    },
    employeeColorCategoryId: {
      get: function() {
        return this.employee.employee_color_category_id;
      },
      set: function(newValue) {
        this.categoryLoading = true;
        this.$store
          .dispatch("employees/update", {
            id: this.employee.id,
            employee_color_category_id: newValue
          })
          .then(res => {
            this.categoryErrors = [];
            this.categorySuccesses.push("Saved!");
            this.successClear = setInterval(() => {
              this.wipeSuccesses();
            }, 1500);
          })
          .catch(res => {
            this.categoryErrors.push("Couldn't be saved");
          })
          .finally(res => {
            this.categoryLoading = false;
          });
      }
    }
  },
  data: function() {
    return {
      teamSearch: "",
      ineligibleTeamSearch: "",
      defaultSort: {
        sortBy: "name",
        ascending: true,
        rowsPerPage: 10
      },
      teamHeaders: [
        {
          text: "Name",
          value: "name"
        }
      ],
      ineligibleTeamHeaders: [
        {
          text: "Name",
          value: "name"
        }
      ],
      teamSelectionLoading: false,
      teamSelectionErrors: [],
      teamSelectionSuccesses: [],
      categoryLoading: false,
      categoryErrors: [],
      categorySuccesses: [],
      addTeamDialog: false,
      addTeamsIneligibleDialog: false,
      removeTeamsIneligibleDialog: false,
      ineligibleTeamsSelected: [],
      ineligibleTeamsSelectedToRemove: [],
      apiCallPending: false,
      narrativeNotesApiCallPending: false,
      teamsSelected: [],
      teamsPullOffSelected: [],
      narrativeNotesDialog: false,
      narrativeNotes: this.employee.narrative_notes
    };
  },
  methods: {
    addTeams(tagIDs) {
      if (!tagIDs || tagIDs.length === 0) {
        return;
      }
      tagIDs.forEach(tid => {
        const tag = this.tagByID(tid);
        const worksites = tag.worksites;
        worksites.forEach(w => {
          if (!this.teamsSelected.map(w => w.id).includes(w.id)) {
            this.teamsSelected.push(w);
          }
        });
      });
    },

    toggleAll: function() {
      if (this.teamsPullOffSelected.length > 0) {
        this.teamsPullOffSelected = [];
      } else {
        this.teamsPullOffSelected = this.employee.teams.slice();
      }
    },
    ineligibleToggleAll: function() {
      if (this.ineligibleTeamsSelectedToRemove.length > 0) {
        this.ineligibleTeamsSelectedToRemove = [];
      } else {
        this.ineligibleTeamsSelectedToRemove = this.employee.ineligible_teams.slice();
      }
    },
    employeeOnTeam: function(teamId) {
      if (this.employee.teams.map(t => t.id).indexOf(teamId) > -1) {
        return true;
      }
      return false;
    },
    employeeIneligibleForTeam: function(teamId) {
      if (this.employee.ineligible_teams.map(t => t.id).indexOf(teamId) > -1) {
        return false;
      }
      return true;
    },
    toggleTeamSelected: function(team) {
      if (this.teamsSelected.indexOf(team) > -1) {
        this.teamsSelected = this.teamsSelected.filter(t => t !== team);
      } else {
        this.teamsSelected.push(team);
      }
    },
    toggleTeamPullOffSelected: function(team) {
      if (this.teamsPullOffSelected.indexOf(team) > -1) {
        this.teamsPullOffSelected = this.teamsPullOffSelected.filter(
          t => t !== team
        );
      } else {
        this.teamsPullOffSelected.push(team);
      }
    },
    toggleTeamRemoveIneligibleSelected: function(team) {
      if (this.ineligibleTeamsSelectedToRemove.indexOf(team) > -1) {
        this.ineligibleTeamsSelectedToRemove = this.ineligibleTeamsSelectedToRemove.filter(
          t => t !== team
        );
      } else {
        this.ineligibleTeamsSelectedToRemove.push(team);
      }
    },
    teamIsSelected: function(team) {
      if (this.teamsSelected.indexOf(team) > -1) {
        return true;
      }
    },
    teamIsPullOffSelected: function(team) {
      if (this.teamsPullOffSelected.indexOf(team) > -1) {
        return true;
      }
    },
    teamIsRemoveIneligibleSelected: function(team) {
      if (this.ineligibleTeamsSelectedToRemove.indexOf(team) > -1) {
        return true;
      }
    },
    wipeSuccesses: function() {
      this.categorySuccesses = [];
    },
    addToAllTeams: function() {
      this.teamsSelected = this.teamsNotOn.slice();
      this.addSelectedTeams();
    },
    addSelectedTeams: function() {
      this.teamSelectionLoading = true;
      this.$store
        .dispatch("employees/addTeams", {
          id: this.employee.id,
          team_ids: this.teamsSelected.map(t => t.id)
        })
        .then(res => {
          this.teamSelectionErrors = [];
          this.teamSelectionSuccesses.push("Saved!");
          this.successClear = setInterval(() => {
            this.teamSelectionErrors = [];
          }, 1500);
        })
        .catch(res => {
          this.teamSelectionErrors.push("Couldn't be saved");
        })
        .finally(res => {
          this.teamSelectionLoading = false;
          this.teamsSelected = [];
        });
      this.apiCallPending = false;
      this.addTeamDialog = false;
    },
    addSelectedIneligibleTeams: function() {
      this.teamSelectionLoading = true;
      this.$store.dispatch("employees/addIneligibleTeams", {
        id: this.employee.id,
        ineligible_teams: this.ineligibleTeamsSelected.map(t => t.id)
      }),
        this.$store
          .dispatch("employees/pullOffTeams", {
            id: this.employee.id,
            team_ids: this.ineligibleTeamsSelected.map(t => t.id)
          })
          .then(res => {
            this.teamSelectionErrors = [];
            this.teamSelectionSuccesses.push("Saved!");
            this.successClear = setInterval(() => {
              this.teamSelectionErrors = [];
            }, 1500);
          })
          .catch(res => {
            this.teamSelectionErrors.push("Couldn't be saved");
          })
          .finally(res => {
            this.teamSelectionLoading = false;
            this.ineligibleTeamsSelected = [];
          });
      this.apiCallPending = false;
      this.addTeamDialog = false;
    },
    removeSelectedIneligibleTeams: function() {
      if (this.ineligibleTeamsSelectedToRemove.length == 0) {
        return;
      }
      // this.teamSelectionLoading = true;
      this.$store
        .dispatch("employees/removeIneligibleTeams", {
          id: this.employee.id,
          ineligible_team_ids: this.ineligibleTeamsSelectedToRemove.map(
            t => t.id
          )
        })
        .then(res => {
          // this.teamSelectionErrors = []
          // this.teamSelectionSuccesses.push("Saved!")
          // this.successClear = setInterval(() => {
          //   this.teamSelectionErrors = []
          // }, 1500);
        })
        .catch(res => {
          // this.teamSelectionErrors.push("Couldn't be saved")
        })
        .finally(res => {
          // this.teamSelectionLoading = false;
          this.ineligibleTeamsSelectedToRemove = [];
        });
      this.apiCallPending = false;
    },
    pullOffTeams: function() {
      if (this.teamsPullOffSelected.length == 0) {
        return;
      }
      // this.teamSelectionLoading = true;
      this.$store
        .dispatch("employees/pullOffTeams", {
          id: this.employee.id,
          team_ids: this.teamsPullOffSelected.map(t => t.id)
        })
        .then(res => {
          // this.teamSelectionErrors = []
          // this.teamSelectionSuccesses.push("Saved!")
          // this.successClear = setInterval(() => {
          //   this.teamSelectionErrors = []
          // }, 1500);
        })
        .catch(res => {
          // this.teamSelectionErrors.push("Couldn't be saved")
        })
        .finally(res => {
          // this.teamSelectionLoading = false;
          this.teamsPullOffSelected = [];
        });
      this.apiCallPending = false;
    },
    saveNarrativeNotes: function() {
      this.narrativeNotesApiCallPending = true;

      this.$store
        .dispatch("employees/saveNarrativeNotes", {
          id: this.employee.id,
          narrative_notes: this.employee.narrative_notes
        })
        .then(res => {})
        .catch(res => {})
        .finally(res => {
          this.narrativeNotes = this.employee.narrative_notes;
          this.narrativeNotesApiCallPending = false;
          this.narrativeNotesDialog = false;
        });
    },

    resetNarrativeNotes: function() {
      this.narrativeNotesDialog = false;
      this.employee.narrative_notes = this.narrativeNotes;
    }
  }
};
</script>

<style scoped>
.selected {
  background: grey;
  color: white;
}
</style>
